/* eslint-disable ember/no-controller-access-in-routes */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class ReportBuilderRoute extends Route {
  @service
  router;

  queryParams = {
    type: { refreshModel: false },
  };

  setupController(controller, model, transition) {
    super.setupController(...arguments);
    let type = transition.to.queryParams.type || 'report';
    controller.setupForNew(type);
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.cleanup();
  }

  activate() {
    super.activate(...arguments);
    if (this.onRouteWillChange) {
      this.router.off('routeWillChange', this.onRouteWillChange);
    }
    this.onRouteWillChange = (transition) => {
      // transition.abort() below fires a second routeWillChange for a
      // synthetic "settling back" transition with isAborted already true.
      // Bail out here or we'd re-run this check and call abort() on it too,
      // recursing forever.
      if (transition.isAborted) {
        return;
      }
      let controller = this.controller;
      if (controller.isDirty && !controller.isSaving) {
        if (
          !window.confirm(
            'You have unsaved changes. Are you sure you want to leave?',
          )
        ) {
          transition.abort();
        }
      }
    };
    this.router.on('routeWillChange', this.onRouteWillChange);
  }

  deactivate() {
    super.deactivate(...arguments);
    if (this.onRouteWillChange) {
      this.router.off('routeWillChange', this.onRouteWillChange);
      this.onRouteWillChange = null;
    }
  }
}
